import { getCartItems } from '../cart/cart-reducer';
import { isRewardFundAsGiftCard, mapCartItemMetadataToGreetingTextForPayment } from '../project/reward/reward-model';

export const getVippsForm = (state) => state.vippsForm;
export const getVippsEnabled = (state) => state.features.vippsEnabled;
export const getVippsGiveMaxAmount = (state) => state.paymentConfig.vippsGiveMaxAmount;

export const getGreetingCardForm = (state) => state.greetingCardForm;
export const getGiftCardForm = (state) => state.giftCardForm;
export const getPaymentForm = (state) => state.paymentForm;
export const getGreetingCardForPayment = (state, projectId) => {
    const cartItems = getCartItems(state, projectId) || [];
    const cardCardItem = cartItems?.find((item) => isRewardFundAsGiftCard(item?.reward));

    if (!cardCardItem) {
        return undefined;
    }
    return mapCartItemMetadataToGreetingTextForPayment(cardCardItem.metadata);
};

export const getGiftCardForPayment = (state) => {
    const giftCardForm = getGiftCardForm(state);

    return {
        receiverName: giftCardForm.receiverName,
        giverName: giftCardForm.giverName,
        greetingText: giftCardForm.greetingText,
        cardType: giftCardForm.type,
    };
};
